const DEAL_NOT_EDITABLE_CODE = 'dealNotEditable';

/**
 * Checks whether the given value represents a `dealNotEditable` error.
 *
 * Accepts:
 * - A string error code (e.g. from DomainException.code)
 * - A DomainException-shaped object ({ __typename: 'DomainException', code })
 */
export function isDealNotEditableError(codeOrResult: unknown): boolean {
  if (typeof codeOrResult === 'string') {
    return codeOrResult === DEAL_NOT_EDITABLE_CODE;
  }

  if (
    codeOrResult &&
    typeof codeOrResult === 'object' &&
    '__typename' in codeOrResult
  ) {
    const obj = codeOrResult as { __typename?: string; code?: string };
    return (
      obj.__typename === 'DomainException' &&
      obj.code === DEAL_NOT_EDITABLE_CODE
    );
  }

  return false;
}
